// extracted by mini-css-extract-plugin
module.exports = {"root":"dFwG1","transparent":"_3lXoS","iconHolder":"_1-uxw","iconLabel":"_25jTs"};